module.exports = __webpack_public_path__ + "img/spin_btn.f23e5304.png";